/**
 * Delete Device Form Schema
 * 
 * Defines the validation for device deletion confirmation.
 * deviceNumber is provided as a parameter.
 * 
 * Form metadata (name, title, description) is loaded from form.yml
 */

import { z } from 'zod'
import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'

// Load form configuration from YAML
const formConfig = FormConfigLoader.loadFormConfig(formYaml)

// ============================================================================
// Export Form Metadata from YAML
// ============================================================================

export const FORM_CONFIG = formConfig
export const FORM_NAME = formConfig.formName
export const FORM_TITLE = formConfig.formTitle
export const FORM_DESCRIPTION = formConfig.formDescription

// ============================================================================
// Constants
// ============================================================================

const MIN_NUMBER = 1000000000
const MAX_NUMBER = 9999999999

// ============================================================================
// Form Schema
// ============================================================================

export const DeleteDeviceFormSchema = z.object({
  // Device identifier (provided as parameter)
  deviceNumber: z
    .number()
    .gte(MIN_NUMBER)
    .lte(MAX_NUMBER),

  // Device name (for display only, read-only field)
  deviceName: z
    .string()
    .min(1, 'Device name is required'),
})

export type DeleteDeviceFormData = z.infer<typeof DeleteDeviceFormSchema>

/**
 * Transform form data to API request format for deletion.
 */
export function transformToApiRequest(formData: DeleteDeviceFormData) {
  return {
    deviceNumber: formData.deviceNumber,
  }
}
